import { api } from './api';
import { mockDashboardData } from '../utils/mockData';

class DashboardService {
  constructor() {
    this.baseUrl = '/dashboard';
  }

  // Obtener datos completos del dashboard
  async getDashboard() {
    try {
      const response = await api.get(this.baseUrl);
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      throw error;
    }
  }

  // Obtener gráficas favoritas
  async getGraficasFavoritas() {
    try {
      const response = await api.get(`${this.baseUrl}/graficas-favoritas`);
      return response.data;
    } catch (error) {
      console.error('Error fetching graficas favoritas:', error);
      console.warn('Using mock data for graficas favoritas');
      return {
        success: true,
        data: mockDashboardData.graficasFavoritas,
        message: 'Datos de prueba cargados'
      };
    }
  }

  // Obtener contadores
  async getContadores() {
    try {
      const response = await api.get(`${this.baseUrl}/contadores`);
      return response.data;
    } catch (error) {
      console.error('Error fetching contadores:', error);
      console.warn('Using mock data for contadores');
      return {
        success: true,
        data: mockDashboardData.contadores,
        message: 'Datos de prueba cargados'
      };
    }
  }

  // Obtener últimos sensores consultados
  async getUltimosSensores() {
    try {
      const response = await api.get(`${this.baseUrl}/ultimos-sensores`);
      return response.data;
    } catch (error) {
      console.error('Error fetching ultimos sensores:', error);
      console.warn('Using mock data for ultimos sensores');
      return {
        success: true,
        data: mockDashboardData.ultimosSensores,
        message: 'Datos de prueba cargados'
      };
    }
  }

  // Obtener consumo de energía
  async getConsumoEnergia() {
    try {
      const response = await api.get(`${this.baseUrl}/consumo-energia`);
      return response.data;
    } catch (error) {
      console.error('Error fetching consumo energia:', error);
      console.warn('Using mock data for consumo energia');
      return {
        success: true,
        data: mockDashboardData.consumoEnergia,
        message: 'Datos de prueba cargados'
      };
    }
  }

  // Marcar/desmarcar gráfica como favorita
  async toggleFavoriteGrafica(id, favorita) {
    try {
      const response = await api.patch(`${this.baseUrl}/grafica/${id}/favorita`, { favorita });
      return response.data;
    } catch (error) {
      console.error('Error toggling favorite grafica:', error);
      throw error;
    }
  }

  // Obtener resumen de proyecto
  async getProyectoResumen(proyectoId) {
    try {
      const response = await api.get(`${this.baseUrl}/proyecto/${proyectoId}/resumen`);
      return response.data;
    } catch (error) {
      console.error('Error fetching proyecto resumen:', error);
      throw error;
    }
  }
}

export default new DashboardService();
